module.exports = __webpack_public_path__ + "img/weixin.1ad6bdf2.png";